import React, { useState } from 'react';
import * as Styles from './AiChatPopover.styles';
import Snappy from '@/media/guide/AiGuide/snappy.png';
import { Button, IconClose } from 'gatorcomponents';
import { STEPS } from './AiChatPopover.types';

const AiChatPopover = ({ homeGuideLocale, name, handleClose }) => {
  const [step, setStep] = useState(STEPS.SALUTE);
  const handleClickClose = () => {
    handleClose && handleClose();
  };

  const handleNextStep = () => {
    if (step === STEPS.I_AM_EVERYWHERE) {
      return;
    }
    setStep(prevStep => prevStep + 1);
  };

  const SaluteHeader = () => (
    <>
      <Styles.Image src={Snappy} />
      <Styles.SaluteMessage>{homeGuideLocale.steps[step].salute(name)}</Styles.SaluteMessage>
    </>
  );

  return (
    <Styles.Wrapper id="AiChatPopover">
      <Styles.RoundButton onClick={handleClickClose}>
        <IconClose />
      </Styles.RoundButton>

      <Styles.Header>
        {step === STEPS.SALUTE ? <SaluteHeader />
          : (
            <Styles.BannerImage src={homeGuideLocale.steps[step].img} />
          )}
      </Styles.Header>

      <Styles.Content>
        <Styles.ContentTitle data-testid="title">
          {homeGuideLocale.steps[step].title}
        </Styles.ContentTitle>

        <Styles.ContentDescription data-testid="description">
          {homeGuideLocale.steps[step].description}
        </Styles.ContentDescription>

        <Styles.ActionsRow>
          <span>
            {homeGuideLocale.currentStep({
              current: step,
              total: Object.keys(STEPS).length,
            })}
          </span>
          <Button
            variant="primary"
            onClick={step === STEPS.I_AM_EVERYWHERE ? handleClickClose : handleNextStep}
            label={step === STEPS.I_AM_EVERYWHERE
              ? homeGuideLocale.gotItCta
              : homeGuideLocale.nextCta}
          />
        </Styles.ActionsRow>
      </Styles.Content>
    </Styles.Wrapper>
  );
};


export default AiChatPopover;
